import { Tabs, Form, Typography, Space } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dayjs from 'dayjs';
import {
  CardWrapper,
  renderTabBarPayment
} from '../MarkupAndBaseRateStyledWrapper/MarkupAndBaseRateStyledWrapper';
import PartnerBaseRateConfigurationForm from './PartnerBaseRateConfigurationForm';
import { BASE_RATE_MODE_CONSTANT } from './const';

const ConfigsTabs = styled(Tabs)`
  && {
    .ant-tabs-content-holder {
      padding: 0 15px;
      padding-bottom: 30px;
    }
  }
`;

function PartnerBaseRateModeWise({
  baseRateForm,
  productKey,
  productValue,
  baseRateFormValues,
  formButtonDisabled,
  updatedAt
}) {
  const getBaseRateModeValue = (key) => BASE_RATE_MODE_CONSTANT[key]?.value || key;
  return (
    <Form form={baseRateForm} layout="vertical" name={[productKey]} disabled={formButtonDisabled}>
      <CardWrapper
        title={
          <Space style={{ gap: '34px', display: 'flex' }}>
            <Typography.Text style={{ fontWeight: 500, fontSize: '16px' }}>
              Base Rate{' '}
            </Typography.Text>
            <Typography.Text style={{ fontSize: '14px', color: '#8F93A8' }}>
              (Last Updated on {dayjs(updatedAt).format('DD/MM/YYYY')})
            </Typography.Text>
          </Space>
        }
      >
        <ConfigsTabs
          key={`${productKey}`}
          defaultActiveKey="1"
          tabPosition="left"
          tabBarGutter={8}
          renderTabBar={renderTabBarPayment}
          items={Object.entries(productValue).map(([mode]) => {
            return {
              label: getBaseRateModeValue(mode),
              key: mode,
              children: (
                <>
                  <PartnerBaseRateConfigurationForm
                    productKey={productKey}
                    mode={mode}
                    baseRateForm={baseRateForm}
                    baseRateFormValues={baseRateFormValues}
                  />
                  <Typography.Text style={{ fontSize: '14px', color: '#8F93A8' }}>
                    *All rates are exclusive of GST. The above numbers are reflective of the true
                    value.
                  </Typography.Text>
                </>
              )
            };
          })}
        />
      </CardWrapper>
    </Form>
  );
}

PartnerBaseRateModeWise.propTypes = {
  productValue: PropTypes.instanceOf(Object).isRequired,
  baseRateFormValues: PropTypes.func.isRequired,
  productKey: PropTypes.string.isRequired,
  baseRateForm: PropTypes.func.isRequired,
  formButtonDisabled: PropTypes.bool.isRequired,
  updatedAt: PropTypes.string.isRequired
};

export default PartnerBaseRateModeWise;
